import { render, staticRenderFns } from "./DetailsPayments.vue?vue&type=template&id=510b0c52&scoped=true&"
import script from "./DetailsPayments.vue?vue&type=script&lang=js&"
export * from "./DetailsPayments.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPayments.vue?vue&type=style&index=0&id=510b0c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b0c52",
  null
  
)

export default component.exports